var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Guide"},[_c('img',{staticClass:"img",attrs:{"src":_vm.img+'?v='+Math.random(),"alt":""},on:{"click":_vm.goAplat}})])}
var staticRenderFns = []

export { render, staticRenderFns }